<template>
  <!-- <ExploreMap class="map-wrapper" v-slot="{isMapActive, toggleMapView}"> -->
  <AmexDiningDetails @show-details="onShowPoiDetailsFromMap" :category="exploreCategory" :selectedDay="selectedDate">
    <template v-slot:header>
      <AmexDetailsHeader class="details-header" :items="headerIcons" @change-view="onSelectDetailsView">
        <!-- <li class="search-wrapper">
          <button class="btn-clear nav-link find-places-btn">
            <SearchIcon />
            <span>Find Places</span>
            <div class="search">
              <AmexSearchInput
                placeholder="Type a Hotel, Restaurant or Place.."
                :isIconVisible="false"
                class="search-input"
                :value="searchInputValue"
                @input="onSearchInputChangeEv"
              />
              <div class="search-section-wrapper" v-if="searchOptions.length || filterOptions.length">
                <span class="title">Places</span>
                <AmexDropdown :active="searchOptions.length > 0" class="dropdown">
                  <ExpItem
                    v-for="item in searchOptions"
                    :key="item.id"
                    :activity="item"
                    :isRemoveAllowed="false"
                    class="select-option"
                    @click="onSelectSearchPoi(item)"
                  />
                </AmexDropdown>
              </div>
              <div class="search-section-wrapper" v-if="filterOptions.length">
                <span class="title">Filters</span>
                <AmexDropdown :active="filterOptions.length > 0" class="dropdown">
                  <InterestDropItem
                    @click="toggleTag(item)"
                    :value="item.parent"
                    :label="item.text"
                    :tag="item"
                    class="select-option"
                    v-for="item in filterOptions"
                    :key="item.id"
                  />
                </AmexDropdown>
              </div>
            </div>
          </button>

        </li> -->
      </AmexDetailsHeader>
    </template>
    <h1 class="page-geader">Explore Things to Do</h1>
  </AmexDiningDetails>
  <!-- </ExploreMap> -->
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed, defineComponent, ref} from '@vue/composition-api';
import {AmexSearchInput, AmexDropdown, InterestDropItem} from '@mobi-components/amex-bluesky-components';
import {useCommonFind} from '../../solution-views/explore-view/common-find';
import {useSolutionViews} from '../../solution-views/solution-views';
import AmexDiningDetails from '../../solution-views/explore-view/solution-dining-details-content.vue';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
// import ExploreMap from '../explore-map/explore-map.vue';
import {useRouter} from '@/router';
import {ToggleComponent} from '@mobi-components/toggle';
import '@mobi-components/toggle/dist/toggle.css';
import SearchIcon from '../../svg/search.vue';
import ExpItem from '../../explore-page/exp-list/exp-item.vue';
import {loadRecommendationDetails} from '@/store/state/helpers';
import {ProblmSubmissionRoute} from '@/store/state/global.types';
import AmexDetailsHeader from '../details-header.vue';

Vue.use(VueCompositionAPI);

export default defineComponent({
  components: {
    // ExploreMap,
    AmexDetailsHeader,
    AmexDiningDetails,
    ToggleComponent,
    SearchIcon,
    AmexSearchInput,
    AmexDropdown,
    ExpItem,
    InterestDropItem,
  },
  setup(_, {root}) {
    const {headerIcons, onSelectDetailsView, onShowPoiDetailsFromMap} = useSolutionViews(root);
    const selectedDate = computed(() => {
      const router = useRouter();
      const date = parseInt(router.currentRoute.query?.date || 0, 10);
      return date;
    });
    const loadAdditionalExperiences = async () => {
      await loadRecommendationDetails(ProblmSubmissionRoute.SOLUTION);
      return null;
    };

    const category = ref(UserActivityCategoryEnum.EXPERIENCE);
    return {
      headerIcons,
      onSelectDetailsView,
      exploreCategory: UserActivityCategoryEnum.EXPERIENCE,
      onShowPoiDetailsFromMap,
      selectedDate,
      ...useCommonFind(category, onShowPoiDetailsFromMap, loadAdditionalExperiences),
    };
  },
});
</script>

<style lang="sass" scoped>
@import '../btn-trip-summary.scss'
@import '../../solution-views/explore-view/common-explore-view.scss'
</style>
